module.exports = __webpack_public_path__ + "img/ep-croissant.d89651c0.jpg";